import { useTranslation } from 'react-i18next';
import { Seo } from '../components/Seo';
import { company } from '../data/company';

export function About() {
  const { t } = useTranslation();

  return (
    <>
      <Seo
        title={`About GyroNavi | ${company.name}`}
        description={`${company.name} is a high-tech enterprise specializing in R&D, manufacturing, and sales of inertial navigation sensors and systems since 2009.`}
        path="/company"
      />
      <section className="section max-w-4xl">
        <p className="eyebrow">{t('company:eyebrow')}</p>
        <h1 className="mt-2 text-4xl font-black text-ink">{t('company:title')}</h1>
        <p className="mt-3 text-lg text-slate-500">{t('company:subtitle')}</p>

        <h2 className="mt-10 text-2xl font-black text-ink">{company.name}</h2>
        <div className="mt-4 space-y-4 leading-8 text-slate-600">
          <p>{t('company:p1')}</p>
          <p>{t('company:p2')}</p>
          <p>{t('company:p3')}</p>
          <p>{t('company:p4')}</p>
        </div>

        <h2 className="mt-10 text-2xl font-black text-ink">{t('company:journeyTitle')}</h2>
        <p className="mt-2 text-slate-500">{t('company:journeySubtitle')}</p>
      </section>
    </>
  );
}
